import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'font-awesome/css/font-awesome.min.css';
import './App.css';
ReactDOM.render(<App/>, document.getElementById('root'));
